import { isWeb } from '@droplet-tech-code/core-elements/module/utils/utils.helper';
import { useState } from 'react';

import { PageContainer, ScreenTwoPageLayout } from '~/components/Page/Page.Container';
import { ScreenPropVouchersByAdminRef } from '~/navigation/Navigation.types';

import { VoucherItemComponent } from '../Voucher.Item';
import { VoucherList, VoucherListNative } from './VoucherByAdminRef.List';

export const VoucherByAdminRefScreen = (props: ScreenPropVouchersByAdminRef) => {
  return (
    <PageContainer>
      <VoucherByAdminRefLayout {...props} />
    </PageContainer>
  );
};

export const VoucherByAdminRefLayout = (props: ScreenPropVouchersByAdminRef) => {
  const voucherAdminRef = props.route.params?.voucherAdminRef;
  const [id, setId] = useState<string | undefined>(props.route.params?.id);

  return (
    <ScreenTwoPageLayout>
      {isWeb ? (
        <VoucherList
          voucherAdminRef={voucherAdminRef}
          onPress={(voucherId) => {
            setId(voucherId);
          }}
        />
      ) : (
        <VoucherListNative voucherAdminRef={voucherAdminRef} />
      )}
      {id ? (
        <VoucherItemComponent voucherId={id} onClose={() => setId(undefined)} />
      ) : (
        <></>
      )}
    </ScreenTwoPageLayout>
  );
};
